var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-red-50 px-4 py-2 my-4 text-red-700 border border-red-300 rounded-lg",domProps:{"textContent":_vm._s(_vm.error)}})}
var staticRenderFns = []

export { render, staticRenderFns }